"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _immutable = require("immutable");

var DealStage = (0, _immutable.Record)({
  active: true,
  closedWon: false,
  displayOrder: -1,
  label: '',
  probability: 0,
  stageId: undefined
}, 'DealStage');

DealStage.fromJS = function (json) {
  if (!json || (0, _typeof2.default)(json) !== 'object') {
    return json;
  }

  return DealStage(json);
};

var _default = DealStage;
exports.default = _default;
module.exports = exports.default;